let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6QS6n")).then(() => parcelRequire('jfJw2'));